import { SkuType } from 'entities/mechanic';
import { useMemo } from 'react';

export const useSkuValuesByIds = (skus: SkuType[], ids: number[]) => {
  const cache = useMemo(
    () =>
      skus.reduce((acc: Record<SkuType['id'], SkuType>, curr) => {
        acc[curr.id] = curr;
        return acc;
      }, {}),
    [skus],
  );

  if (!skus.length || !ids.length) {
    return [];
  }

  return ids.reduce((acc: SkuType[], curr) => {
    acc.push(cache[curr]);
    return acc;
  }, []);
};
